export const SELECT_PARTNER = "@partner/SELECT_USER";

export const INITIALIZE_CREATE_PARTNER = "@partner/INITIALIZE_CREATE_PARTNER";

export const UPDATE_NAME = "@partner/UPDATE_NAME";
export const UPDATE_ADDRESS = "@partner/UPDATE_ADDRESS";
export const UPDATE_WEBSITE = "@partner/UPDATE_WEBSITE";
export const UPDATE_PHONE = "@partner/UPDATE_PHONE";
export const UPDATE_CITY = "@partner/UPDATE_CITY";
export const UPDATE_POSTCODE = "@partner/UPDATE_POSTCODE";
export const UPDATE_COUNTRY = "@partner/UPDATE_COUNTRY";
export const UPDATE_TYPE = "@partner/UPDATE_TYPE";
export const UPDATE_PIC_NAME = "@partner/UPDATE_PIC_NAME";
export const UPDATE_PIC_EMAIL = "@partner/UPDATE_PIC_EMAIL";
export const UPDATE_PIC_PHONE = "@partner/UPDATE_PIC_PHONE";
export const UPDATE_PIC_POSITION = "@partner/UPDATE_PIC_POSITION";
export const UPDATE_PIC_DEPARTMENT = "@partner/UPDATE_PIC_DEPARTMENT";

export const GET_PARTNER_REQUEST = "@partner/GET_PARTNER_REQUEST";
export const GET_PARTNER_SUCCESS = "@partner/GET_PARTNER_SUCCESS";
export const GET_PARTNER_FAILURE = "@partner/GET_PARTNER_FAILURE";

export const GET_DETAIL_PARTNER_REQUEST = "@partner/GET_DETAIL_PARTNER_REQUEST";
export const GET_DETAIL_PARTNER_SUCCESS = "@partner/GET_DETAIL_PARTNER_SUCCESS";
export const GET_DETAIL_PARTNER_FAILURE = "@partner/GET_DETAIL_PARTNER_FAILURE";

export const UPDATE_PARTNER_REQUEST = "@partner/UPDATE_PARTNER_REQUEST";
export const UPDATE_PARTNER_SUCCESS = "@partner/UPDATE_PARTNER_SUCCESS";
export const UPDATE_PARTNER_FAILURE = "@partner/UPDATE_PARTNER_FAILURE";

export const CREATE_PARTNER_REQUEST = "@partner/CREATE_PARTNER_REQUEST";
export const CREATE_PARTNER_SUCCESS = "@partner/CREATE_PARTNER_SUCCESS";
export const CREATE_PARTNER_FAILURE = "@partner/CREATE_PARTNER_FAILURE";